import { useFetchConnectedIntegrations } from '@modules/integrationsV2/hooks';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';

interface UseGetConnectedIntegrationsOptions {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const useGetConnectedIntegrationWorkspaces = ({
  channelType,
  integrationType,
}: UseGetConnectedIntegrationsOptions) => {
  const { connectedIntegrations } = useFetchConnectedIntegrations({
    fetchPolicy: 'cache-first',
  });

  const connectedWorkspaces =
    connectedIntegrations
      .filter(
        (integration) =>
          integration.channel.type === channelType &&
          integration.integrationType === integrationType &&
          integration.isActive,
      )
      .map((integration, index) => ({
        id: integration.id,
        name:
          integration.externalID ||
          `${integration.channel.displayName} ${index + 1}`,
      })) ?? [];

  return connectedWorkspaces;
};
